// BankReconciliationPageBasiq.js
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useReconciliationStore } from '../store/reconciliationStore';
import { getMatchSuggestions } from '../utils/simpleMatcher';
import { fetchInvoices } from '../../../services/InvoiceService';
import { fetchExpenses } from '../../../services/BillsExpensesService';
// Assuming you have a service file or hook configured for Basiq API requests
import { fetchBasiqTransactions } from './service/BasiqService';
import { useAuth } from '../../../../AuthProvider';
import ReconciliationActions from '../components/ReconciliationActions';
import { Table, Card, Badge, Typography, Empty, Alert, Button, Spin, Space, Tag, Tabs } from 'antd';
import { FileDoneOutlined, SyncOutlined, CheckCircleTwoTone, CloseCircleTwoTone, WalletOutlined } from '@ant-design/icons';
import { fetchFiskilTransactions } from '../fiskil/service/FiskilService';
// 2. Fetch Live Bank Feed from Basiq API

const { Title, Text } = Typography;

const BankReconciliationPageBasiq = () => {
  const {
    transactions,
    selectedTransaction,
    setSelectedTransaction,
    setSuggestions,
    setTransactions
  } = useReconciliationStore();

  const auth = useAuth();
  const [invoices, setInvoices] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [tnxSug, setTnxSug] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchingBankFeed, setFetchingBankFeed] = useState(false);
  const [financialContext, setFinancialContext] = useState(null);

  // Focus reference container to capture arrow keystrokes natively
  const tableContainerRef = useRef(null);

  // 1. Fetch Invoices and Expenses on Component Mount
  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      try {
        const [invRes, expRes] = await Promise.all([
          fetchInvoices(auth.token),
          fetchExpenses(auth.token,auth.additionalUserInfo.companyId)
        ]);
        setInvoices(invRes.data || []);
        setExpenses(expRes.data || []);
      } catch (e) {
        console.error("Error fetching financial documents:", e);
        setInvoices([]);
        setExpenses([]);
      } finally {
        setLoading(false);
      }
    };
    fetchAllData();
  }, [auth.token]);

  const loadFinancialKnowledgeBase = async () => {
    const fContext = [
      {
        "userId": "user_001",
        "companyId": "company_123",
        "type": "expense",
        "note": "Team lunch at Tree Cafe",
        "amount": 22.64,
        "currency": "AUD",
        "timestamp": "2026-06-24T12:30:00Z",
        "merchant": "Tree Cafe",
        "confidence": "user_reported"
      },
      {
        "userId": "user_002",
        "companyId": "company_123",
        "type": "income",
        "note": "Signed contract with Unisys for implementation project",
        "amount": 15000,
        "currency": "AUD",
        "timestamp": "2026-06-24T09:00:00Z",
        "counterparty": "Unisys",
        "expectedPaymentSchedule": [
          { "amount": 5000, "stage": "deposit" },
          { "amount": 5000, "stage": "milestone_1" },
          { "amount": 5000, "stage": "completion" }
        ],
        "confidence": "user_reported"
      },
      {
        "userId": "user_003",
        "companyId": "company_123",
        "type": "expense",
        "note": "Purchased office supplies for new project setup",
        "amount": 185.50,
        "currency": "AUD",
        "timestamp": "2026-06-23T15:10:00Z",
        "categoryHint": "office_supplies",
        "confidence": "user_reported"
      },
      {
        "userId": "user_001",
        "companyId": "company_123",
        "type": "income",
        "note": "Received partial payment from client for Phase 1 delivery",
        "amount": 5000,
        "currency": "AUD",
        "timestamp": "2026-06-24T08:45:00Z",
        "counterparty": "Unisys",
        "linkedContractHint": "Unisys implementation project",
        "confidence": "user_reported"
      }
    ];
  };


  // ... Inside your component ...

  const loadBasiqBankFeed = useCallback(async () => {
    setFetchingBankFeed(true);
    try {
      const basiqRes = await fetchFiskilTransactions(auth.token, auth.additionalUserInfo.fiskilUserId, auth.additionalUserInfo.companyId);
      /*const basiqResAsString = {
      "type": "list",
      "count": 500,
      "size": 887,
      "data": [
        {
          "type": "transaction",
          "id": "9fc664dc-d33b-4b6e-b425-7b050d9d49bb",
          "status": "posted",
          "description": "NAPA GLEN IRIS VI AUS",
          "amount": "-22.64",
          "account": "431a5c73-2c6d-4947-9cc9-0d88b450299b",
          "balance": "0.00",
          "direction": "debit",
          "class": "payment",
          "institution": "AU00000",
          "connection": "8e1490d1-24ac-4b1b-9e4e-8a55df895f91",
          "reference": "",
          "enrich": null,
          "currency": "AUD",
          "transactionDate": "2026-06-23T08:45:42Z",
          "postDate": "2026-06-26T08:45:42Z",
          "subClass": {
            "title": "Cafes, Restaurants and Takeaway Food Services",
            "code": "451"
          },
          "paymentDetails": null,
          "links": {
            "self": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/transactions/9fc664dc-d33b-4b6e-b425-7b050d9d49bb",
            "account": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/accounts/431a5c73-2c6d-4947-9cc9-0d88b450299b",
            "institution": "https://au-api.basiq.io/institutions/AU00000",
            "connection": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/connections/8e1490d1-24ac-4b1b-9e4e-8a55df895f91"
          }
        },
        {
          "type": "transaction",
          "id": "9gc664dc-d33b-4b6e-b425-7b050d9d49bb",
          "status": "posted",
          "description": "Zul Al-Kabir",
          "amount": "928.00",
          "account": "431a5c73-2c6d-4947-9cc9-0d88b450299b",
          "balance": "0.00",
          "direction": "credit",
          "class": "payment",
          "institution": "AU00000",
          "connection": "8e1490d1-24ac-4b1b-9e4e-8a55df895f91",
          "reference": "I-7a5e1417-ab97-44be-bda8-5102cc7b8012",
          "enrich": null,
          "currency": "AUD",
          "transactionDate": "2026-06-23T08:45:42Z",
          "postDate": "2026-06-26T08:45:42Z",
          "subClass": {
            "title": "Customer payments and other credits",
            "code": "451"
          },
          "paymentDetails": null,
          "links": {
            "self": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/transactions/9fc664dc-d33b-4b6e-b425-7b050d9d49bb",
            "account": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/accounts/431a5c73-2c6d-4947-9cc9-0d88b450299b",
            "institution": "https://au-api.basiq.io/institutions/AU00000",
            "connection": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/connections/8e1490d1-24ac-4b1b-9e4e-8a55df895f91"
          }
        },
        {
          "type": "transaction",
          "id": "9ec664dc-d33b-4b6e-b425-7b050d9d49bb",
          "status": "posted",
          "description": "Zul Al-Kabir",
          "amount": "1779.80",
          "account": "431a5c73-2c6d-4947-9cc9-0d88b450299b",
          "balance": "0.00",
          "direction": "credit",
          "class": "payment",
          "institution": "AU00000",
          "connection": "8e1490d1-24ac-4b1b-9e4e-8a55df895f91",
          "reference": "I-7a5e1417-ab97-44be-bda8-5102cc7b8012",
          "enrich": null,
          "currency": "AUD",
          "transactionDate": "2026-06-23T08:45:42Z",
          "postDate": "2026-06-26T08:45:42Z",
          "subClass": {
            "title": "Customer payments and other credits",
            "code": "451"
          },
          "paymentDetails": null,
          "links": {
            "self": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/transactions/9fc664dc-d33b-4b6e-b425-7b050d9d49bb",
            "account": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/accounts/431a5c73-2c6d-4947-9cc9-0d88b450299b",
            "institution": "https://au-api.basiq.io/institutions/AU00000",
            "connection": "https://au-api.basiq.io/users/0de43eb1-e0ec-4a08-b6e7-23f79abe863c/connections/8e1490d1-24ac-4b1b-9e4e-8a55df895f91"
          }
        }
      ]
    };*/
      //const basiqRes = basiqResAsString["data"];

      // Explicitly guarantee you have an array before sending to Zustand
      if (Array.isArray(basiqRes) && basiqRes.length > 0) {
        // --- ADDED SORTING ENGINE LOGIC HERE ---
        const sortedBasiqRes = [...basiqRes].sort((a, b) => {
  // Use .getTime() to force comparison of numerical milliseconds
  const dateA = a.execution_date_time ? new Date(a.execution_date_time).getTime() : 0;
  const dateB = b.execution_date_time ? new Date(b.execution_date_time).getTime() : 0;
  
  return dateA - dateB; // Ascending order (oldest to newest)
});
        const updated = sortedBasiqRes.map(tx => {
          const suggestions = getMatchSuggestions(tx, invoices, expenses);
          //console.log('Updated suggestions for selected transaction:', suggestions);

          let reconciliationStatus = 'UNMATCHED';
          if (tx.reconciliationStatus === 'RECONCILED') {
            reconciliationStatus = 'RECONCILED';
          } else if (suggestions && suggestions.length > 0) {
            reconciliationStatus = 'MATCHED';
          }

          return {
            ...tx,
            reconciliationStatus,
            suggestions: suggestions,
          };
        });



        setTransactions(updated);

        const index = updated.findIndex(
          tx => tx.reconciliationStatus !== 'RECONCILED'
        );
        console.log('First outstanding transaction index:', index);
        setSelectedTransaction(updated[index - 1]?.id || null);
        const sel = updated[index - 1];
        setSelectedRecord(sel);
        const selSuggestions = getMatchSuggestions(sel, invoices, expenses);
        setSuggestions(selSuggestions);

      }
    } catch (error) {
      console.error("Failed to sync Basiq bank feed:", error);
    } finally {
      setFetchingBankFeed(false);
    }
  }, [invoices, expenses]); // Functions are safely memoized

  const sortItems = (items, direction) => {
    if (direction === 'asc') {
      return [...items].sort((a, b) => {
        const dateA = a.execution_date_time ? new Date(a.execution_date_time).getTime() : 0;
        const dateB = b.execution_date_time ? new Date(b.execution_date_time).getTime() : 0;
        return dateA - dateB;
      });
    } else if (direction === 'desc') {
      return [...items].sort((a, b) => {
        const dateA = a.execution_date_time ? new Date(a.execution_date_time).getTime() : 0;
        const dateB = b.execution_date_time ? new Date(b.execution_date_time).getTime() : 0;
        return dateB - dateA;
      });
    } else {
      return items; // No sorting applied
    }
  }
  // Safely trigger once on mount
  useEffect(() => {
    loadBasiqBankFeed();
  }, [loadBasiqBankFeed]);
  // Trigger Basiq fetch once invoices/expenses are loaded, or on demand
  useEffect(() => {
    loadBasiqBankFeed();
  }, []);

  // Shared Helper function to programmatically select a transaction record safely
  const handleSelectTransaction = useCallback((recordOrId) => {
    if (!recordOrId) return;
    const currentTxId = recordOrId.id ? recordOrId.id : recordOrId;
    const sel = tnxSug.find(t => t.id === currentTxId);
    if (sel) {
      setSelectedTransaction(currentTxId);
      setSelectedRecord(sel);
      const selSuggestions = getMatchSuggestions(sel, invoices, expenses);
      setSuggestions(selSuggestions);
    }
  }, [tnxSug, invoices, expenses, setSelectedTransaction, setSuggestions]);

  // Dynamic Listeners for Up/Down arrow keyboard actions
  const handleKeyDown = (e) => {
    if (tnxSug.length === 0) return;

    const currentId = typeof selectedTransaction === 'object' ? selectedTransaction?.id : selectedTransaction;
    const currentIndex = tnxSug.findIndex(tx => tx.id === currentId);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const nextIndex = currentIndex < tnxSug.length - 1 ? currentIndex + 1 : 0;
      handleSelectTransaction(tnxSug[nextIndex]);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prevIndex = currentIndex > 0 ? currentIndex - 1 : tnxSug.length - 1;
      handleSelectTransaction(tnxSug[prevIndex]);
    }
  };

  // 3. Process Live Match Suggestions whenever transactions, invoices, or expenses update
  useEffect(() => {
    if (transactions && transactions.length > 0) {
      const updated = transactions.map(tx => {
        const suggestions = getMatchSuggestions(tx, invoices, expenses);
        //console.log('Updated suggestions for selected transaction:', suggestions);

        let reconciliationStatus = 'UNMATCHED';
        if (tx.reconciliationStatus === 'RECONCILED') {
          reconciliationStatus = 'RECONCILED';
        } else if (suggestions && suggestions.length > 0) {
          reconciliationStatus = 'MATCHED';
        }

        return {
          ...tx,
          reconciliationStatus,
          suggestions: suggestions,
        };
      });
      //console.log('Updated transactions with suggestions:', updated);
      //setTransactions(updated);
      setTnxSug(updated);



      // Keep Selected Record sync updated when data mutations occur
      if (selectedTransaction) {
        const currentId = typeof selectedTransaction === 'object' ? selectedTransaction?.id : selectedTransaction;
        const currentIndex = updated.findIndex(tx => tx.id === currentId);
        const nextIndex = currentIndex < updated.length - 1 ? currentIndex + 1 : 0;
        handleSelectTransaction(updated[nextIndex]);
        /*const currentSel = updated.find(t => t.id === selectedTransaction);
        if (currentSel) {
          setSelectedRecord(currentSel);
          const selSuggestions = getMatchSuggestions(currentSel, invoices, expenses);
          setSuggestions(selSuggestions);
        }*/
      } else {

        /*const index = updated.findIndex(
  tx => tx.reconciliationStatus !== 'RECONCILED'
);
      console.log('First outstanding transaction index:', index);
        setSelectedTransaction(updated[index]?.id || null);
      const sel = updated[index];
      setSelectedRecord(sel);
      const selSuggestions = getMatchSuggestions(sel, invoices, expenses);
      setSuggestions(selSuggestions);*/
      }

    } else {
      setTnxSug([]);
      setSuggestions([]);
    }
  }, [transactions]);

  // 4. Update suggestions explicitly when individual transaction selection changes
  useEffect(() => {
    if (selectedTransaction && tnxSug.length > 0) {
      const targetId = selectedTransaction.id ? selectedTransaction.id : selectedTransaction;
      const sel = tnxSug.find(t => t.id === targetId);
      if (sel) {
        setSelectedRecord(sel);
        const selSuggestions = getMatchSuggestions(sel, invoices, expenses);
        setSuggestions(selSuggestions);
      }
    } else {
      setSuggestions([]);
      setSelectedRecord(null);
    }
  }, [selectedTransaction, tnxSug]);

  // Focus key listener automatically when page interaction mounts
  useEffect(() => {
    if (tableContainerRef.current) {
      tableContainerRef.current.focus();
    }
  }, [tnxSug]);

  // 5. Ant Design Table Columns mapped directly to Basiq's data structure
  const columns = [
    {
      title: 'Date',
      dataIndex: 'execution_date_time',
      key: 'execution_date_time',
      // Format Basiq ISO date string "2026-06-23T08:45:42Z" to human-readable form
      render: (dateStr) => {
        if (!dateStr) return <Text>-</Text>;
        const dateObj = new Date(dateStr);
        return <Text>{dateObj.toLocaleDateString()}</Text>;
      },
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (desc, record) => (
        <Space direction="vertical" size={0}>
          <Text strong>{desc}</Text>
          {record.subClass && (
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {record.subClass.title}
            </Text>
          )}
        </Space>
      ),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      render: (amt, record) => {
        const numericAmount = Math.abs(Number(amt));
        const isDebit = record.direction === 'debit' || Number(amt) < 0;
        return (
          <Text type={isDebit ? 'danger' : 'success'} strong>
            {isDebit ? '-' : '+'}${numericAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </Text>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'reconciliationStatus',
      key: 'reconciliationStatus',
      render: (status) => {
        if (status === 'RECONCILED') return <Badge status="success" text="Reconciled" />;
        if (status === 'MATCHED') return <Badge status="warning" text="Matched" />;
        return <Badge status="processing" text="Unmatched" />;
      },
    },
  ];

  const currentSelectionId = selectedTransaction?.id || selectedTransaction;

  // Split transaction feeds dynamically into filtered view subsets based on reconciliationStatus
  const outstandingTransactions = tnxSug.filter(tx => tx.reconciliationStatus !== 'RECONCILED');
  const reconciledTransactions = sortItems(tnxSug, 'desc').filter(tx => tx.reconciliationStatus === 'RECONCILED');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', background: '#f4f6fa' }}>

      {/* TOP HALFTIME WRAPPER: Scrollable Bank Transactions Feed */}
      <div
        ref={tableContainerRef}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        style={{ height: '40%', padding: 24, background: '#fff', overflowY: 'auto', borderBottom: '2px solid #e5e7eb', outline: 'none' }}
      >
        <Card bordered={false} style={{ marginBottom: 16, background: '#f0f5ff' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div style={{ flex: 1 }}>
              <Title level={4} style={{ margin: 0 }}><WalletOutlined /> Basiq Automated Bank Feed</Title>
              <Text type="secondary">Real-time Open Banking Transaction Pipeline (Use Up/Down Arrow Keys to navigate)</Text>
            </div>
            <Button
              type="primary"
              icon={<SyncOutlined spin={fetchingBankFeed} />}
              onClick={loadBasiqBankFeed}
              loading={fetchingBankFeed}
            >
              Sync Feed
            </Button>
          </div>
        </Card>

        <Title level={5} style={{ marginBottom: 12 }}>Bank Transactions</Title>

        <Spin spinning={loading || fetchingBankFeed} tip="Loading bank feed metrics...">
          <Tabs defaultActiveKey="outstanding" type="card" style={{ background: '#fff' }}>
            <Tabs.TabPane tab="Not Reconciled Yet" key="outstanding">
              <Table
                dataSource={outstandingTransactions}
                columns={columns}
                rowKey="id"
                size="middle"
                pagination={false}
                rowClassName={(record) => (currentSelectionId === record.id ? 'selected-reconciliation-row' : '')}
                onRow={(record) => ({
                  onClick: () => {
                    setSelectedTransaction(record.id);
                    setSelectedRecord(record);
                    if (record) {
                      const selSuggestions = getMatchSuggestions(record, invoices, expenses);
                      setSuggestions(selSuggestions);
                    }
                  },
                  style: { cursor: 'pointer' },
                })}
                locale={{
                  emptyText: <Empty description="No outstanding transactions found." />
                }}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Already Reconciled" key="reconciled">
              <Table
                dataSource={reconciledTransactions}
                columns={columns}
                rowKey="id"
                size="middle"
                pagination={false}
                rowClassName={(record) => (currentSelectionId === record.id ? 'selected-reconciliation-row' : '')}
                onRow={(record) => ({
                  onClick: () => {
                    setSelectedTransaction(record.id);
                    setSelectedRecord(record);
                    if (record) {
                      const selSuggestions = getMatchSuggestions(record, invoices, expenses);
                      setSuggestions(selSuggestions);
                    }
                  },
                  style: { cursor: 'pointer' },
                })}
                locale={{
                  emptyText: <Empty description="No reconciled transactions found." />
                }}
              />
            </Tabs.TabPane>
          </Tabs>
        </Spin>
      </div>

      {/* BOTTOM HALFTIME WRAPPER: Contextual Detail Matching Execution Frame */}
      <div style={{ height: '60%', padding: 24, background: '#f9fafb', overflowY: 'auto' }}>
        {selectedRecord ? (
          <Card
            title={<span><FileDoneOutlined /> Transaction Details</span>}
            bordered={false}
            style={{ marginBottom: 16, boxShadow: '0 2px 8px #f0f1f2' }}
            extra={
              selectedRecord.reconciliationStatus === 'RECONCILED' ? (
                <CheckCircleTwoTone twoToneColor="#52c41a" />
              ) : selectedRecord.reconciliationStatus === 'MATCHED' ? (
                <CheckCircleTwoTone twoToneColor="#faad14" />
              ) : (
                <CloseCircleTwoTone twoToneColor="#ff4d4f" />
              )
            }
          >
            <div style={{ marginBottom: 8 }}>
              <Text type="secondary">Date/Time:</Text>{' '}
              <Text>{new Date(selectedRecord.transactionDate).toLocaleString()}</Text>
            </div>
            <div style={{ marginBottom: 8 }}>
              <Text type="secondary">Description:</Text> <Text strong>{selectedRecord.description}</Text>
            </div>
            <div style={{ marginBottom: 8 }}>
              <Text type="secondary">Category:</Text>{' '}
              <Tag color="blue">{selectedRecord.subClass?.title || 'Unclassified'}</Tag>
            </div>
            <div style={{ marginBottom: 8 }}>
              <Text type="secondary">Amount ({selectedRecord.currency}):</Text>{' '}
              <Text strong underline>
                ${Math.abs(Number(selectedRecord.amount)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </Text>{' '}
              <Badge status={selectedRecord.direction === 'debit' ? 'error' : 'success'} text={selectedRecord.direction} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <Text type="secondary">Status:</Text>{' '}
              {selectedRecord.reconciliationStatus === 'RECONCILED' && <Badge status="success" text="Reconciled" />}
              {selectedRecord.reconciliationStatus === 'MATCHED' && <Badge status="warning" text="Matched" />}
              {selectedRecord.reconciliationStatus === 'UNMATCHED' && <Badge status="error" text="Unmatched" />}
            </div>

            <hr style={{ border: '0.5px solid #f0f0f0', marginBottom: 16 }} />

            {/* Context action handlers update their global hooks dynamically */}
            <ReconciliationActions handleSelectTransaction={handleSelectTransaction} selectedTransaction={selectedTransaction} selectedRecord={selectedRecord} setSelectedRecord={setSelectedRecord} />
          </Card>
        ) : (
          <Alert
            message="Action Required"
            description="Select an active transaction from your Basiq bank feed layout pane to start the validation mapping."
            type="info"
            showIcon
            style={{ marginTop: 32 }}
          />
        )}
      </div>

      {/* Embedded Shading Style Block */}
      <style>{`
        .selected-reconciliation-row {
          background-color: #e6f7ff !important;
          border-left: 4px solid #1890ff !important;
          transition: background-color 0.15s ease-in-out;
        }
        .selected-reconciliation-row:hover > td {
          background-color: #e6f7ff !important;
        }
      `}</style>
    </div>
  );
};

export default BankReconciliationPageBasiq;